<template>
  <div class="campainRange">
    <div class="MeasurementBus">
      <div class="MeasurementBus__header">
        <div class="MeasurementBus__header__left">
          <div class="MeasurementBus__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
          <adx-dropdown-list class="status" @selected="selectedStatus" :valueDisplay="selectedStatusValue" :list="statusList" labelButton="All Status" />
          <button v-if="filtered" class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
        <div class="MeasurementBus__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync= "isLoading"
      :items.sync="data"  
      :isEmpty.sync="isEmpty"  
      @selectedAction="selectedAction">
    </adx-table>
    <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="selectedPage"
      @change-page="selectPage"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'

import { parseErrorGql } from '@/lib/error'
import { helpers } from '@/lib/validation/'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-measurement-bus',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-list': ListDropdown,
    'adx-table': table, LabelStatus,
  },
  props: {

  },
  data() {
    return {
      retryCount: 0,
      isLoading: true,
      searchBoxValue:'',
      selectedStatusValue:'',
      selectedStatusLabel:'',
      selectedPage: 1,
      currentPage: 1,
      count: 0,
      maxPage: 1,
      selectedSortValue: 'first_added',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "PAYMENT",
            type: "statuslabel"
          },
          {
            title: "ITEMS",
            type: "text"
          },
          {
            title: "",
            type: "icon"
          },
          {
            title: "",
            type: "icon"
          }
        ],
        body : []
      },
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Upcoming',
          value: "upcoming"
        },
        {
          id: 2,
          label: 'Active',
          value: "active"
        },
        {
          id: 3,
          label: 'Expired',
          value: "expired"
        },
        {
          id: 4,
          label: 'Canceled',
          value: "canceled"
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
    }),
    // isLoading: function(){
    //   return this.$apollo.loading || false
    // },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    filtered: function() {
      let filtered = false
      if (this.selectedStatusValue) {
        filtered = true
      }
      return filtered
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        // this.$apollo.queries.busCampaignMeasurementsPage.refetch()
        this.loadData()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        // this.$apollo.queries.busCampaignMeasurementsPage.refetch()
        this.loadData()
      }
    },
    selectedStatusValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        // this.$apollo.queries.busCampaignMeasurementsPage.refetch()
        this.loadData()
      })
    },
    
  },
  // apollo: {
  //   busCampaignMeasurementsPage: {
  //     query: require('@/graphql/bus/measurementsPage.gql'),
  //     variables(){
  //       return {
  //         search: this.searchBoxValue || undefined,
  //         sort: this.selectedSortValue || undefined,
  //         statusFilter: this.selectedStatusValue || undefined,
  //         page: this.currentPage.toString() || "1"
  //       }
  //     },
  //     loadingKey: 'loading',
  //     result(data) {
  //       const { busCampaignMeasurementsPage } = data.data
  //       if (busCampaignMeasurementsPage){
  //          this.mapData(busCampaignMeasurementsPage)
  //       }
  //     }
  //   },
  // },
  beforeCreate() {
    
  },
  created() {

  },
  beforeMount() {

  },
  async mounted() {
    localStorage.setItem('apollo-token', this.token)
    const { page } = this.$route.query
    if(page){
      this.selectedPage = parseInt(page)
    }
   await this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      let response = null
      try {
        response = await this.$apollo.query({
          query: require('@/graphql/bus/measurementsPage.gql'),
          fetchPolicy: 'network-only',
          errorPolicy:'all',
          variables: {
            search: this.searchBoxValue || undefined,
            sort: this.selectedSortValue || undefined,
            paymentFilter: this.selectedPaymentValue || undefined,
            statusFilter: this.selectedStatusValue || undefined,
            page: this.selectedPage.toString() || "1"
          },
        })
      } catch(err) {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Network error!`,
          type: 'danger'
        });
        this.$router.push({ name: `500` })
      }

      if (response.data) {
        if (response.errors) {
          this.handleError(response.errors)
        } else {
          const { busCampaignMeasurementsPage } = response.data
          if (busCampaignMeasurementsPage){
            this.mapData(busCampaignMeasurementsPage)
          }
        }
      }
    },
    async handleError(error) {
      const parsedError = parseErrorGql(error)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.retryCount++
          if (this.retryCount<3) {
            await this.loadData()
          } else{
            this.isLoading = false
            this.isEmpty=true
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Something went wrong. Please refresh the page!`,
              type: 'danger'
            });
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async mapData(busCampaignMeasurementsPage){
      let body = []
      let result = busCampaignMeasurementsPage.campaignMeasurements
      let meta = busCampaignMeasurementsPage.meta
      await result.forEach(res => {
        let statusDisplay = this.getStatusDisplay(res.status)
        let statusPaymentDisplay = this.getStatusPaymentDisplay(res.payment)
        let item = this.displayTotalItem(res.items)
        let valuesData = [
          { value: res.id},
          { value: statusDisplay.value, label: statusDisplay.label},
          { value: res.campaign},
          { start: res.start, end:res.end},
          { value: statusPaymentDisplay.value, label: statusPaymentDisplay.label},
          { value: item},
          { icon: "icon-edit", text: "Edit"},
          { icon: "icon-copy", text: "View Report"}
        ]
        body.push({
          id: res.id,
          values:valuesData
        })
      });
      this.data.body = body
      this.maxPage = meta.maxPage
      this.count = meta.count
      this.isLoading = false
    },
    countRoutes(item) {
      let count = 0
      if(item) {
        item.forEach(route => {
          count += route.count
        });
      }
      return count
    },
    displayTotalItem(item) {
      if (item == 0) {
        return '-'
      } else if (item == 1){
        return `${item} Buses`
      } else {
      return `${item} Buses`
      }
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `draft`:
          res = { id: 0, value: 'draft', label: 'DRAFT', status: 'draft'}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: 'verifying'}
          break
        case `active`:
          res = { id: 2, value: 'active', label: 'ACTIVE', status: 'active'}
          break
        case `expired`:
          res = { id: 3, value: 'expired', label: 'EXPIRED', status: 'expired'}
          break
        case `cancel`:
          res = { id: 4, value: 'canceled', label: 'CANCELED', status: 'cancel'}
          break
        case `dormant`:
          res = { id: 5, value: 'dormant', label: 'DORMANT', status: 'dormant'}
          break
        case `upcoming`:
          res = { id: 4, value: 'upcoming', label: 'UPCOMING', status: 'upcoming'}
      }
      return res
    },
    getStatusPaymentDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `pending`:
          res = { id: 0, value: 'pending', label: 'PENDING', status: 'pending'}
          break
        case `afterpay`:
          res = { id: 1, value: 'afterpay', label: 'AFTERPAY', status: 'afterpay'}
          break
        case `paid`:
          res = { id: 2, value: 'paid', label: 'PAID', status: 'paid'}
          break
        case `downpayment`:
          res = { id: 3, value: 'downpayment', label: 'DOWNPAYMENT', status: 'downpayment'}
          break
        case `partially`:
          res = { id: 4, value: 'partially', label: 'PARTIALLY', status: 'partially'}
      }
      return res
    },
    selectedPayment(item){
      this.selectedPaymentValue = item.value
      this.selectedPaymentLabel = item.id.toString()
    },
    selectedStatus(item){
      this.selectedStatusValue = item.value
      this.selectedStatusLabel = item.id.toString()
    },
    async resetFilter(){
      this.selectedPage = 1
      this.selectedStatusValue = null,
      this.selectedStatusLabel = null
      this.loadData()
      // await this.$apollo.queries.busCampaignMeasurementsPage.refetch()
    },
    selectedAction(id, type, item){
      if(type == 'icon-edit'){
        this.$router.push({name: 'detailbus', params: { id: item.id }})
      } else if(type == 'icon-copy'){
        this.$router.push({name: 'busreport', params: { id: item.id }})
      } else{
        this.$router.push({name: 'home'})
      }
    },
    async selectPage(item) {
      this.selectedPage = item
      this.loadData()
      // await this.$apollo.queries.busCampaignMeasurementsPage.refetch()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
</style>